import { z } from 'zod';
import { tagHealthNotificationMetadataSchema } from './ITagHealthNotificationMetadata';
import { planningCreatedNotificationMetadataSchema } from './IPlanningCreatedNotificationMetadata';
import { distressButtonNotificationMetadataSchema } from './IDistressButtonNotificationMetadata';
import { restrictedAreaNotificationMetadataSchema } from './IRestrictedAreaNotificationMetadata';
import { createdIssuesNotificationMetadataSchema } from './ICreatedIssuesNotificationMetadata';
import { issueAssigneeUpdatedNotificationMetadataSchema } from './IIssueAssigneeUpdatedNotificationMetadata';
import { issueStatusUpdatedNotificationMetadataSchema } from './IIssueStatusUpdatedNotificationMetadata';
import { areaSequenceItemStatusUpdateNotificationMetadataSchema } from './IAreaSequenceItemStatusUpdateNotificationMetadata';
import { issueCommentCreatedNotificationMetadataSchema } from './IIssueCommentCreatedNotificationMetadata';

// Schemas (source of truth)
// DailyReport and SequenceProgressAnalysisReport don't send metadata.
export const notificationMetadataSchema = z.union([
	restrictedAreaNotificationMetadataSchema,
	distressButtonNotificationMetadataSchema,
	planningCreatedNotificationMetadataSchema,
	tagHealthNotificationMetadataSchema,
	createdIssuesNotificationMetadataSchema,
	areaSequenceItemStatusUpdateNotificationMetadataSchema,
	issueAssigneeUpdatedNotificationMetadataSchema,
	issueStatusUpdatedNotificationMetadataSchema,
	issueCommentCreatedNotificationMetadataSchema,
]);

// Types (derived from schemas)
export type INotificationMetadata = z.infer<typeof notificationMetadataSchema>;
